var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute flex h-3 w-3 items-center justify-center rounded-full bg-ontick-blue-600",class:_vm.positionClass},[_c('span',{staticClass:"h-3 w-3 animate-ping rounded-full bg-ontick-blue-600"}),_c('span',{staticClass:"sr-only"},[_vm._v(" Você tem novas mensagens ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }